import React from "react";
import { RiDeleteBin6Line } from "react-icons/ri";
import { ReactSortable } from "react-sortablejs";

const DescriptionForm = ({ data, setData, err, handleDescriptionChange, handleAddDescription, handleDeleteDescription }) => {
  // Sortable list handler
  const handleSort = (newList) => {
    setData((prevData) => ({
      ...prevData,
      description: newList,
    }));
  };

  return (
    <ReactSortable
      list={data?.description || []}
      setList={handleSort}
      animation={200}
      delayOnTouchStart
      delay={2}
      // Add these props to fix input field issues
      handle=".sortIcon"
      filter=".form-control"
      preventOnFilter={false}
    >
      {(data?.description || []).map((desc, i) => (
        <div className="row sorting__design" key={desc.id || `desc-${i}`}>
          <div className="col-12 col-md-6">
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                value={desc?.desc_points || ""}
                placeholder="Type here"
                onChange={(e) =>
                  handleDescriptionChange(i, e.target.value, "desc_points")
                }
              />
              <small id="error" className="error">
                {err[`desc_points_${i}`]}
              </small>
            </div>
          </div>
          {data?.description?.length > 1 && (
            <div className="col-12 col-md-1 sort__img">
              <div className="mb-0">
                <RiDeleteBin6Line
                  size={30}
                  onClick={() => handleDeleteDescription(i)}
                  className="delete_icon"
                />
              </div>
              <img src="/assets/img/filter.svg" className="sortIcon" alt="" />
            </div>
          )}
          {data?.description?.length === i + 1 && (
            <div className="col-12 col-md-1">
              <div className="mb-0">
                <button onClick={handleAddDescription} className="btn btn-primary">
                  Add
                </button>
              </div>
            </div>
          )}
        </div>
      ))}
    </ReactSortable>
  );
};

export default DescriptionForm;